module.exports = __webpack_public_path__ + "img/af32818ab01a5715b4240bc214b15c93.png";